import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import {
  FormsModule,
  ReactiveFormsModule,
  FormBuilder,
  FormGroup,
  Validators,
  FormArray,
  FormControl,
} from '@angular/forms';
import { ActivatedRoute, NavigationEnd, Params, Router } from '@angular/router';
@Component({
    selector: 'show-office-info',
    templateUrl: './show-office-info.component.html',
    styleUrls: ['./show-office-info.component.css'],
    standalone: false
})
export class ShowOfficeInfoComponent {
  @Input() public officeInfo: any;
  @Input() public type?: any;
}
